import React, { useState, useEffect } from 'react';
import Carousel from '../components/Carousel';
import MatchCard from '../components/MatchCard';
import NewsList from '../components/NewsList';
import TableStandings from '../components/TableStandings';
import Toast from '../components/Toast';
import { carouselSlides } from '../data/sampleData';
import apiService from '../services/apiService';

const Home = () => {
  const [nextMatch, setNextMatch] = useState(null);
  const [previousMatch, setPreviousMatch] = useState(null);
  const [news, setNews] = useState([]);
  const [standings, setStandings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    loadData();
  }, []);

  // Refresh data when component becomes visible (when navigating back from admin)
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        loadData();
      }
    };

    const handleFocus = () => {
      loadData();
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', handleFocus);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleFocus);
    };
  }, []);

  const loadData = async (showToast = false) => {
    try {
      setLoading(true);
      
      // Fetch data from API
      const [nextMatchData, previousMatchData, newsData, standingsData] = await Promise.all([
        apiService.getUpcomingMatch(),
        apiService.getPreviousMatch(),
        apiService.getPublishedNews(),
        apiService.getStandings()
      ]);

      // Debug logging (removed for production)

      setNextMatch(nextMatchData);
      setPreviousMatch(previousMatchData);
      setNews(newsData);
      setStandings(standingsData);
      setLoading(false);

      if (showToast) {
        setToast({
          message: 'მონაცემები განახლდა',
          type: 'success'
        });
      }
    } catch (error) {
      console.error('Error loading data:', error);
      setLoading(false);
      setToast({
        message: 'მონაცემების ჩატვირთვა ვერ მოხერხდა',
        type: 'error'
      });
    }
  };

  const resetData = () => {
    // Since we're using the API, just reload the data
    loadData(true);
  };

  const showApiData = () => {};

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600 mx-auto"></div>
          <p className="mt-4 text-gray-600 font-georgian">იტვირთება...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Toast Notification */}
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}

      {/* Hero Carousel */}
      <section className="mb-12">
        <Carousel slides={carouselSlides} />
      </section>

      {/* Debug section removed */}

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Left Column - Matches */}
          <div className="lg:col-span-1 space-y-8">
            {nextMatch && <MatchCard match={nextMatch} type="upcoming" onRefresh={() => loadData(true)} />}
            {previousMatch && <MatchCard match={previousMatch} type="previous" onRefresh={() => loadData(true)} />}
          </div>

          {/* Right Column - News and Standings */}
          <div className="lg:col-span-2 space-y-8">
          <TableStandings standings={standings} onRefresh={() => loadData(true)} />
            <NewsList news={news} onRefresh={() => loadData(true)} />
          </div>
        </div>

        {/* Facebook Integration Section */}
        {/* <section className="mt-12">
          <div className="bg-white rounded-lg shadow-lg p-6">
            <h2 className="text-2xl font-bold text-gray-900 font-georgian mb-6">
              ჩვენი Facebook გვერდი
            </h2>
            <div className="bg-gray-100 rounded-lg p-8 text-center">
              <div className="w-16 h-16 bg-primary-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-2xl">f</span>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 font-georgian mb-2">
                FC ივერია - ოფიციალური გვერდი
              </h3>
              <p className="text-gray-600 font-georgian mb-4">
                მიჰყევით ჩვენს Facebook გვერდს უახლესი ამბებისთვის
              </p>
              <a
                href="https://www.facebook.com/khashuris.iveria.arena/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center bg-primary-600 hover:bg-primary-700 text-white font-bold py-3 px-6 rounded-lg transition-colors duration-200 font-georgian"
              >
                Facebook-ზე გადასვლა
              </a>
            </div>
          </div>
        </section> */}
      </div>
    </div>
  );
};

export default Home;
